import dynamic from 'next/dynamic';

export const DitherBackground = dynamic(() => import('./DitherBackgroundInternal'), { ssr: true });
